module.exports = __webpack_public_path__ + "static/media/logotipo.9632d56a.svg";